var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMultiply(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.9494 1.05071C11.3399 1.44123 11.3399 2.07439 10.9494 2.46492L2.46409 10.9502C2.07357 11.3407 1.4404 11.3407 1.04988 10.9502C0.659355 10.5597 0.659355 9.92651 1.04988 9.53599L9.53516 1.05071C9.92568 0.660181 10.5589 0.660181 10.9494 1.05071Z",
    fill: "#4F5E71"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.9492 10.9502C10.5587 11.3408 9.92553 11.3408 9.53501 10.9502L1.04973 2.46496C0.659205 2.07444 0.659205 1.44127 1.04973 1.05075C1.44025 0.660222 2.07342 0.660222 2.46394 1.05075L10.9492 9.53603C11.3397 9.92655 11.3397 10.5597 10.9492 10.9502Z",
    fill: "#4F5E71"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMultiply);
export default __webpack_public_path__ + "static/media/Multiply.836a9e05dde284ec29d5c70eb267dfbc.svg";
export { ForwardRef as ReactComponent };